import { DEFAULT_EMPTY_VALUE, PROVIDER_SOURCES } from 'src/constants/companyReport';
import { formatDate, formatNumber } from 'src/services/companyReportDetail.service';

interface Props {
  activeIndex: string;
  handleOnClick: (index: string) => void;
  detailData: any;
}

const GroupStructure = ({ activeIndex, handleOnClick, detailData }: Props) => {
  const extendedGroupStructure = detailData?.companyProfile?.companyProfile?.extendedGroupStructure;

  return (
    <div className={`card accordion ${activeIndex === 'group-structure' ? 'active' : ''}`}>
      <div className="accordion-heading" onClick={() => handleOnClick('group-structure')}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-4 align-items-center">
            <h4 className="mb-0">GROUP STRUCTURE</h4>
          </div>
          <div>
            <img
              className="chevron-icon"
              src={require('src/assets/images/icons/chevron-down.svg').default}
              alt="chevron-down icon"
            />
          </div>
        </div>
      </div>
      <div className="accordion-content">
        {detailData.source === PROVIDER_SOURCES.DNB ? (
          <DnbGroupStructure extendedGroupStructure={extendedGroupStructure} />
        ) : (
          <DefaultGroupStructure extendedGroupStructure={extendedGroupStructure} />
        )}
      </div>
    </div>
  );
};

const DnbGroupStructure = ({ extendedGroupStructure }: any) => {
  let annualRevenue = extendedGroupStructure?.map((egs: any) =>
    egs.annualRevenue?.length && egs.annualRevenue[0]?.yearlyRevenues?.length
      ? formatNumber(egs.annualRevenue[0]?.yearlyRevenues?.[0].value)
      : DEFAULT_EMPTY_VALUE,
  );

  return (
    <div className="mt-3">
      <table className="accordion-table sm-th-md-td">
        <thead>
          <tr>
            <th>Level</th>
            <th>Company Name</th>
            <th>Country of Incorporation</th>
            <th>Corporate Linkage</th>
            <th>Annual Revenue</th>
            <th>Incorporation Date</th>
          </tr>
        </thead>
        <tbody>
          {extendedGroupStructure?.map((egs: any, index: number) => (
            <tr key={egs.registrationNumber + egs.companyCode}>
              <td>{egs.level ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{egs.companyName ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{egs.countryOfIncorporation ?? DEFAULT_EMPTY_VALUE}</td>
              <td>
                {egs.corporateLinkage?.length
                  ? egs.corporateLinkage[0].description
                  : DEFAULT_EMPTY_VALUE}
              </td>
              <td>{annualRevenue[index] ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{formatDate(egs.latestAnnualAccounts) ?? DEFAULT_EMPTY_VALUE}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const DefaultGroupStructure = ({ extendedGroupStructure }: any) => {
  return (
    <div className="mt-3">
      <table className="accordion-table sm-th-md-td">
        <thead>
          <tr>
            <th>Level</th>
            <th>Name</th>
            <th>Country Code</th>
            <th>Registration Number</th>
            <th>Status</th>
            <th>Last Financials</th>
          </tr>
        </thead>
        <tbody>
          {extendedGroupStructure?.map((egs: any) => (
            <tr key={egs.registrationNumber + egs.companyCode}>
              <td>{egs.level ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{egs.companyName ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{egs.countryCode ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{egs.registrationNumber ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{egs.companyStatus ?? DEFAULT_EMPTY_VALUE}</td>
              <td>{formatDate(egs.latestAnnualAccounts) ?? DEFAULT_EMPTY_VALUE}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GroupStructure;
